<template>
    <div class="flex-col ai-end">
        <div class="item grid" @click="onRowClick" :style="{ cursor: hasDegradations ? 'pointer' : 'default' }">
            <VIcon class="jc-center ai-center" :src="require('@/assets/icons/' + item.monitoring_type + '.svg')"
                :style="{ backgroundColor: rowColor }" />

            <p>{{ item[item.monitoring_type + 'MonitoringDate'] }}</p>
            <p>{{ item[item.monitoring_type + 'MonitoringName'] }}</p>
            <p>{{ item.user.name + ' ' + item.user.surname }}</p>
            <p>{{ item.topographic_element_4_name }}</p>
            <p>{{ item.validated !== 0 ? 'VALIDATA' : 'NON VALIDATA' }}</p>

            <div class="action-buttons">
                <VButton data-testid="show-button" :icon="require('@/assets/icons/m-eye.svg')" @click.stop="onShow" />
                <VButton v-if="item.validated === 0" data-testid="edit-button"
                    :icon="require('@/assets/icons/m-edit.svg')" @click.stop="onEdit" />
                <VButton data-testid="link-button" :icon="require('@/assets/icons/m-geo-pin.svg')"
                    @click.stop="onLink" />
            </div>
        </div>

        <!-- gap tra i blocchi come nel vecchio flex gap-5.
         Se la riga è espansa, il gap lo aggiunge il detail renderer. -->
        <div v-if="!isExpanded" class="row-gap"></div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { getPunctualMonitoringColor } from '@/utils'

const props = defineProps({
    params: { type: Object, required: true }
})

const row = computed(() => props.params.data || {})
const item = computed(() => row.value.item || {})
const hasDegradations = computed(() => !!row.value.hasDegradations)
const isExpanded = computed(() => !!row.value.isExpanded)

const rowColor = computed(() => {
    if (item.value.monitoring_type === 'punctual') return getPunctualMonitoringColor(item.value)
    return item.value.color ? '#' + item.value.color : 'var(--alta-color)'
})

const onRowClick = () => {
    if (!hasDegradations.value) return
    props.params.onToggleExpand?.(item.value)
}

const onShow = () => props.params.onShow?.(item.value)
const onEdit = () => props.params.onEdit?.(item.value)
const onLink = () => props.params.onLink?.(item.value)
</script>

<style scoped>
.item {
    grid-template-columns: 30px 90px 1fr 0.5fr 0.6fr 110px 1fr;
    color: var(--secondary-color);
    width: 100%;
    background-color: var(--base-light-color);
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    text-align: left;
    column-gap: 20px;
}

.item p {
    font-size: 1.2em;
    font-weight: 400;
    line-height: 22px;
    color: var(--secondary-color);
    white-space: nowrap;
}

.item .v-icon {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    display: flex;
}

.action-buttons {
    gap: 13px;
    justify-content: end;
    display: flex;
}

.action-buttons .plain-button {
    margin: 0;
}

.row-gap {
    height: 5px;
    width: 100%;
}
</style>
